import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { managerGanttRef, managerGroupGantt, managerTableKeepGlobalData } from '@tuqqi/web';
import { allowDragWhenFilters, allowDragWhenSort } from '../lib/grid/GridOverride';

const getUpdatedLanesViewsLaneRoot = (lists, info) => {
    const ids = info.newChilds.map(x => x.id)
    return lists.map(x => {
        if(x.id === info.subId) {
            x.parentLaneId = 0
        }
        let order = x.order
        if(ids.includes(x.id)) {
            order = info.newChilds.find(y => y.id === x.id).order
        }
        return {
            ...x,
            order
        }

    })
}

const getUpdatedLanesViewsItemSameLane = (lists, info) => {
    const ids = info.newChilds.map(x => x.id)
    return lists.map(x => {
        let items = x.items ?? []
        let order = x.order
        if(ids.includes(x.id)) {
            order = info.newChilds.find(y => y.id === x.id).order
        }
        items = items.map(i => {
            let oo = i.order
            if(ids.includes(i.documentId)) {
                oo = info.newChilds.find(y => y.id === i.documentId).order
            }
            return {
                ...i,
                order: oo
            }
        })
        return {
            ...x,
            items,
            order
        }
    })
}

const getUpdatedLanesViewsLane = (lists, info) => {
    const {
        toId,
        subId,
        newChilds,
    } = info;
    
    const itemList = lists.find(x => x.id === subId)
    const itemListTo = lists.find(x => x.id === toId)

    const newChildsIds = newChilds.map(x => x.id)

    const orderFromNewChilds = newChilds.find(x => x.id === subId)?.order ?? 0

    if(!itemList || !itemListTo) return lists
    const restLists = lists.filter(x => x.id !== itemList.id && x.id !== itemListTo.id)

    itemList.parentLaneId = toId
    itemList.order = orderFromNewChilds

    const updatedRestLists = restLists.map(x => {
        let order = x.order
        if(newChildsIds.includes(x.id)) {
            order = newChilds.find(y => y.id === x.id).order
        }

        return {
            ...x,
            order
        }
    })

    itemListTo.items = (itemListTo?.items ?? []).map(x => {
        let order = x.order
        if(newChildsIds.includes(x.documentId)) {
            order = newChilds.find(y => y.id === x.documentId).order
        }

        return {
            ...x,
            order
        }
    })

    const newLists = [...updatedRestLists, itemList, itemListTo]
    
    return newLists
}

const getUpdatedLanesViewsItemDifLanes = (lists, info) => {    
    const ids = info.newChilds.map(x => x.id)
    let prevList = lists.find(x => {
        const item = (x?.items ?? []).find(y => y.documentId === info.subId)
        return item
    })
    let prevItem = info.fromId === -1 ? info.prevItem : prevList?.items?.find(x => x.documentId === info.subId)
    
    if(!prevItem) return lists

    prevItem.collectionViewListId = info.toId
    
    return lists.map(x => {
        let items = x.items ?? []
        let order = x.order
        if(ids.includes(x.id)) {
            order = info.newChilds.find(y => y.id === x.id).order
        }

        if(x.id === info.fromId) items = items.filter(y => y.documentId !== info.subId)

        if(x.id === info.toId) {
            items = [...items, prevItem].map(i => {
                let oo = i.order
                if(ids.includes(i.documentId)) {
                    oo = info.newChilds.find(y => y.id === i.documentId).order
                }
                return {
                    ...i,
                    order: oo
                }
            })
        }
        
        return {
            ...x,
            items,
            order
        }
    })
}


//item, lane, defaultLane, root
const getCase = (startRecord) => {
    if(!!startRecord?.originalData?.isRootRow) return 'root'
    if(!!startRecord?.originalData?.isLane && startRecord?.originalData?.id === -1) return 'defaultLane'
    if(!!startRecord?.originalData?.isLane && startRecord?.originalData?.id !== -1) return 'lane'
    if(!!startRecord?.originalData?.isItemRow) return 'item'
    return 'item'
}

//'itemEnd' 'laneEnd'
const getCaseForDragEnd = (context) => {
    if(!context.insertBefore && !!context?.startRecord?.originalData?.isItemRow && !!context?.parent?.originalData?.isLane) return 'itemEnd'
    if(!context.insertBefore && !!context?.startRecord?.originalData?.isLane && !!context?.parent?.originalData?.isRootRow) return 'laneEnd'
    if(!context.insertBefore && !!context?.startRecord?.originalData?.isLane && !!context?.parent?.originalData?.isLane) return 'laneEnd'

    return ''
}

const deniedDropTypes = ['root', 'defaultLane']
const denyDropType = (type) => {
    return deniedDropTypes.includes(type)
}

const resolveLaneDrag = (context) => {
    let v = true
    if(!context.insertBefore) v = false
    if(!context.parent?.originalData?.isRootRow) v = false
    if(!context.insertBefore?.originalData?.isLane) v = false
    if(!!context.insertBefore?.originalData?.isItemRow && context.insertBefore?.parent?.originalData?.isLane && context.insertBefore?.parent?.originalData?.id !== -1) v = true
    if(!!context.insertBefore?.originalData?.isLane && context.insertBefore?.parent?.originalData?.isLane && context.insertBefore?.parent?.originalData?.id !== -1) v = true
    if(context.insertBefore?.originalData?.id === -1) v = false

    return v
}

const resolveItemDrag = (context) => {
    let v = true
    if(!context.insertBefore) v = false
    if(!context.parent?.originalData?.isLane) v = false
    if(context?.insertBefore?.parent?.originalData?.id === -1 && context?.parent?.originalData?.id === -1) v = false
    if(context?.startRecord?.parent?.originalData?.id !== -1 && context?.parent?.originalData?.id === -1) v = true
    // if(context?.startRecord.isNew) v = false

    return v
}

const resolveItemDragForEnd = (context) => {
    let v = true
    if(!!context.insertBefore) v = false
    if(!context.parent?.originalData?.isLane) v = false
    if(context?.parent?.originalData?.id === -1) v = false
    if(context?.startRecord?.parent?.originalData?.id !== -1 && context?.parent?.originalData?.id === -1) v = true
    if(!context.startRecord?.originalData?.isItemRow) v = false
    // if(context?.startRecord.isNew) v = false


    return v
}
const resolveLaneDragForEnd = (context) => {
    let v = true
    if(!!context.insertBefore) v = false
    if(!context.parent?.originalData?.isRootRow && !context.parent?.originalData?.isLane) v = false
    if(context?.parent?.originalData?.id === -1) v = false
    if(context?.startRecord?.parent?.originalData?.id !== -1 && context?.parent?.originalData?.id === -1) v = true
    if(!context.startRecord?.originalData?.isLane) v = false
    if(context.startRecord?.originalData?.id === -1) v = false
    // if(context?.startRecord.isNew) v = false


    return v
}

const uniqueItems = (items) => {
    const presentedIds = []
    const filtered = items.reduce((accum, item) => {
        if(presentedIds.includes(item.id)) return accum
        presentedIds.push(item.id)
        return [...accum, item]
    }, [])
    return filtered
}

const getDataForMoveSubLane = (context) => {
    const newRec = {
        id: context.startRecord.id,
        order: -1,
    }
    const fromId = context.parent?.id 
    const toId = context.insertBefore?.parent?.id
    const subId = context.startRecord.id

    const newParentChilds = (context?.insertBefore?.parent?.children ?? []).map(x => ({id: x.id, order: x.order}))
    const index = newParentChilds.findIndex(node => node.id === context.insertBefore.id);
    if(index === -1) return null
    newParentChilds.splice(index, 0, newRec);
    const newChilds = (uniqueItems(newParentChilds)).map((x, i) => ({...x, order: i}))

    if(!newChilds.length || !fromId || !toId || !subId) return null
    return {
        fromId,
        toId,
        subId,
        newChilds,
    }
}

const getDataForMoveInClosedLane = (startRecord, destRec) => {
    const newRec = {
        id: startRecord.id,
        order: -1,
    }


    const fromId = startRecord?.parent.id
    const toId = destRec?.id
    const subId = startRecord.id

    const newParentChilds = (destRec?.children ?? []).map(x => ({id: x.id, order: x.order}))
    newParentChilds.push(newRec)
    const newChilds = (uniqueItems(newParentChilds)).map((x, i) => ({...x, order: i}))
    
    if(!newChilds.length || !fromId || !toId || !subId) return null
    return {
        fromId,
        toId,
        subId,
        newChilds,
    }
}

const getDataForMoveSubLaneLastPos = (context) => {
    const newRec = {
        id: context.startRecord.id,
        order: -1,
    }

    const _inn = context?.parent?.children?.length
    const insertBefore = context?.parent?.children?.[_inn === undefined ? 0 : _inn - 1]

    const fromId = context.parent?.id 
    const toId = insertBefore?.parent?.id
    const subId = context.startRecord.id

    const newParentChilds = (insertBefore?.parent?.children ?? []).map(x => ({id: x.id, order: x.order}))
    const index = newParentChilds.findIndex(node => node.id === insertBefore.id);
    if(index === -1) return null
    newParentChilds.splice(index, 0, newRec);
    const newChilds = (uniqueItems(newParentChilds)).map((x, i) => ({...x, order: i}))

    if(!newChilds.length || !fromId || !toId || !subId) return null
    return {
        fromId,
        toId,
        subId,
        newChilds,
    }
}

const getDataForMoveSubLaneItem = (context) => {
    const newRec = {
        id: context.startRecord.id,
        order: -1,
    }
    const fromId = context?.oldPositionContext?.[0]?.parentId
    const toId = context.insertBefore?.parent?.id
    const subId = context.startRecord.id

    const newParentChilds = (context?.insertBefore?.parent?.children ?? []).map(x => ({id: x.id, order: x.order}))
    const index = newParentChilds.findIndex(node => node.id === context.insertBefore.id);
    if(index === -1) return null
    newParentChilds.splice(index, 0, newRec);
    const newChilds = (uniqueItems(newParentChilds)).map((x, i) => ({...x, order: i}))
    const prevItem = fromId === -1 ?
    {
        collectionViewListId: toId,
        creationDateTime: new Date().toISOString(),
        documentId: context.startRecord.id,
        id: 0,
        lastModification: new Date().toISOString(),
        order: -1,
        title: context.startRecord.name ?? ""
    } : undefined

    if(!newChilds.length || !fromId || !toId || !subId) return null
    return {
        fromId,
        toId,
        subId,
        prevItem,
        newChilds,
    }
}

const getDataForMoveSubLaneItemLastPos = (context) => {
    const newRec = {
        id: context.startRecord.id,
        order: -1,
    }

    const _inn = context?.parent?.children?.length
    const insertBefore = context?.parent?.children?.[_inn === undefined ? 0 : _inn - 1]
    
    if(!insertBefore) return null
    const fromId = context?.oldPositionContext?.[0]?.parentId
    const toId = insertBefore?.parent?.id
    const subId = context.startRecord.id

    const newParentChilds = (insertBefore?.parent?.children ?? []).map(x => ({id: x.id, order: x.order}))
    const index = newParentChilds.findIndex(node => node.id === insertBefore.id);
    
    if(index === -1) return null
    newParentChilds.splice(index, 0, newRec);
    const newChilds = (uniqueItems(newParentChilds)).map((x, i) => ({...x, order: i}))
    const prevItem = fromId === -1 ?
    {
        collectionViewListId: toId,
        creationDateTime: new Date().toISOString(),
        documentId: context.startRecord.id,
        id: 0,
        lastModification: new Date().toISOString(),
        order: -1,
        title: context.startRecord.name ?? ""
    } : undefined

    if(!newChilds.length || !fromId || !toId || !subId) return null
    return {
        fromId,
        toId,
        subId,
        prevItem,
        newChilds,
    }
}


export const useGanttReorder = (opts) => {
    const {collectionInfo, groupService, dispatch} = opts
    const ganttViewRef = useRef(undefined)
    const colUidRef = useRef(undefined)
    const colIdRef = useRef(undefined)
    const updateMove = useRef(false)
    const accentEl = useRef(null)
    const lockGridElWidth = useRef(0)
    const hoverLaneID = useRef(null)

    const ganttView = useMemo(() => {
        if(!collectionInfo || !Object.keys(collectionInfo).length) return undefined
        const gantt = collectionInfo?.collectionViews?.find?.(x => x.collectionViewType === 'Gantt')
        return gantt
    }, [collectionInfo])

    useEffect(() => {
        ganttViewRef.current = ganttView
    }, [ganttView])

    useEffect(() => {
        if(!collectionInfo) {
            colUidRef.current = undefined
            colIdRef.current = undefined
            return
        }
        colUidRef.current = collectionInfo?.collectionUid ?? undefined
        colIdRef.current = collectionInfo?.id ?? undefined
    }, [collectionInfo])

    const moveLaneView = useCallback((info) => {
        if(!ganttViewRef.current) return
        if(!colIdRef.current || !colUidRef.current) return

        let itemLists = ganttViewRef.current.itemLists
        if(info.fromId === info.toId && info.toId === colUidRef.current){
            itemLists = getUpdatedLanesViewsLaneRoot(ganttViewRef.current.itemLists, info)
        } else {
            itemLists = getUpdatedLanesViewsLane(ganttViewRef.current.itemLists, info)
        }
        ganttViewRef.current.itemLists = itemLists
        const updatedItemLists = [...ganttViewRef.current.itemLists]

        groupService.reorderGantt(colIdRef.current, updatedItemLists)
        updateMove.current = true
        setTimeout(() => {
            dispatch({
                type: 'RESULT_CHANNEL_VIEWS_GANTT',
                itemLists: updatedItemLists
            })
        }, 100)

    }, [])

    const moveSubLaneItem = useCallback( (info) => {
        if(!ganttViewRef.current) return
        if(!colIdRef.current || !colUidRef.current) return

        let itemLists = ganttViewRef.current.itemLists
        if(info.fromId === info.toId){
            itemLists = getUpdatedLanesViewsItemSameLane(ganttViewRef.current.itemLists, info)
        } else {
            itemLists = getUpdatedLanesViewsItemDifLanes(ganttViewRef.current.itemLists, info)
        }
        ganttViewRef.current.itemLists = itemLists
        const updatedItemLists = [...ganttViewRef.current.itemLists]

        const moveLane = {
            collectionId: colUidRef.current,
            docTitle: '',
            sourceLaneId: info.fromId,
            targetLaneId: info.toId,
            cardId: info.subId,
            position: 0,
            collectionViewType: 'Gantt'
        }
        
        groupService.moveGanttCard(moveLane).then((res) => {
            groupService.reorderGantt(colIdRef.current, updatedItemLists)
        })
        updateMove.current = true
        setTimeout(() => {
            dispatch({
                type: 'RESULT_CHANNEL_VIEWS_GANTT',
                itemLists: updatedItemLists
            })
        }, 100)

    }, [])


    const setAccentColor = (valid) => {
        if(!accentEl.current) return
        
        const presented = accentEl.current.classList.contains("drag-invalid-custom")
        if(!valid) {
            if(!presented) accentEl.current.classList.add("drag-invalid-custom")
        } else {
            if(!!presented) accentEl.current.classList.remove("drag-invalid-custom")
        }
    
    }

    const onInZoneCompare = (inZone, _id) => {
        if(inZone) {
            reset()
            hoverLaneID.current = _id
            appyClass(true, _id)
        }
    }

    const isDragInClosedLane = (context, onInZone) => {
        const store = managerGanttRef?.gantt?.instance?.project?.eventStore
        if(!store) return false

        const _id = context?.insertBefore?.id
        const clientY = context.clientY
        const isLane = context?.insertBefore?.data?.isLane
        if(!_id || !isLane) return false
        if(_id === -1 && context?.startRecord?.data?.isLane) return false
        const isExpanded = context?.insertBefore?.isExpanded(store)
        if(!!isExpanded) return false
        const rowDestEl = window.document.querySelectorAll(`[data-id='${_id}']`)?.[0]

        if(!rowDestEl) return false
        const contains = rowDestEl.contains(context.target)

        const bound = rowDestEl.getBoundingClientRect()
        const topPos = bound.top + 10;
        const bottomPos = bound.bottom - 10;

        const inZone = contains && clientY > topPos && clientY < bottomPos
        onInZone?.(inZone, _id)
        
        return inZone
    }

    const appyClass = (inside, id) => {
        if(!hoverLaneID.current) return
        const list = Array.from(window.document.querySelectorAll(`[data-id='${id}']`))

        const rowDestLocked = list.find(x => x.id.includes('locked'))    
        if(!rowDestLocked) return

        const presentedLocked = rowDestLocked.classList.contains("row-reordering-target-custom-locked")
        if(!!inside) {
            if(!presentedLocked) rowDestLocked.classList.add("row-reordering-target-custom-locked")
        } else {
            if(!!presentedLocked) rowDestLocked.classList.remove("row-reordering-target-custom-locked")
        }
    }

    const reset = () => {
        const id = hoverLaneID.current
        if(!id) return
        const list = Array.from(window.document.querySelectorAll(`[data-id='${id}']`))

        const rowDestLocked = list.find(x => x.id.includes('locked'))
        if(!rowDestLocked) return

        rowDestLocked.classList.remove("row-reordering-target-custom-locked")
        hoverLaneID.current = null
    }


    const setupLockGrid = () => {
        const subGrid = window.document.getElementsByClassName("b-grid-subgrid-locked")?.[0]
        if(!subGrid) return
        const width = subGrid?.getBoundingClientRect()?.width

        lockGridElWidth.current = width ?? 0
    }

    const setupDropIndicator = () => {
        if(!accentEl.current) {
            accentEl.current = window.document.getElementsByClassName("b-row-drop-indicator")?.[0]
        }
        
        if(accentEl.current && lockGridElWidth.current) {
            accentEl.current.style.width = `${lockGridElWidth.current}px`
            accentEl.current.style.minWidth = `${lockGridElWidth.current}px`
            accentEl.current.style.maxWidth = `${lockGridElWidth.current}px`
        }        
    }

    const gridRowBeforeDragStart = useCallback(() => {
        setupLockGrid()
    }, [])

    const gridRowDrag = useCallback(({context}) => {
        setupDropIndicator();

        const moveInClosedLane = isDragInClosedLane(context, onInZoneCompare)
        if(!moveInClosedLane) reset()

        if(!!moveInClosedLane) {
            setAccentColor(true)
            context.valid = true;
            return true
        }

        
        if(!context.startRecord) {
            context.valid = false
            setAccentColor(false)
            return false
        }

        const typeEndDrag = getCaseForDragEnd(context)

        if(typeEndDrag === 'laneEnd') {
            const valid = resolveLaneDragForEnd(context)
            setAccentColor(valid)

            context.valid = valid
            return valid
        }
        if(typeEndDrag === 'itemEnd') {
            const valid = resolveItemDragForEnd(context)
            setAccentColor(valid)
            context.valid = valid
            return valid
        }

        if(!context.insertBefore) {
            setAccentColor(false)
            context.valid = false
            return false
        }

        const type = getCase(context.startRecord)
        if(!!denyDropType(type)) {
            setAccentColor(false)

            context.valid = false
            return false
        }
        switch (type) {
            case 'lane': {
                const valid = resolveLaneDrag(context)
                setAccentColor(valid)

                context.valid = valid
                return valid
            }
            case 'item': {
                const valid = resolveItemDrag(context)
                setAccentColor(valid)

                context.valid = valid
                return valid
            }
            default: {
                context.valid = false
                setAccentColor(false)

                return false
            }
        }
    }, [])

    const onMoveInClosedLaneManual = (context) => {
        const source = context.startRecord
        const dest = context.insertBefore

        const info = getDataForMoveInClosedLane(context.startRecord, context.insertBefore)

        const store = managerGanttRef?.gantt?.instance?.project?.eventStore
        if(!store) return
        if(!dest) return
        if(!source) return

        const parentOfSource = source?.parent
        if(!parentOfSource) return

        dest.appendChild(source)
        parentOfSource.removeChild(source)

        
        if(!info) return false
        const isLane = !!source?.data?.isLane
        isLane ? moveLaneView(info) : moveSubLaneItem(info)
    }

    const gridRowBeforeDropFinalize = useCallback(({context}) => {
        if(getCase(context.startRecord) === 'item' && !context?.startRecord?.data?.editable?.groupOfTask) {
            const itemName = context.startRecord.name ?? 'Untitled'
            const groupName = managerGroupGantt.getKeepGroupTitle()
            managerTableKeepGlobalData.showSnackbar("You don't have the permission to move the {{itemName}} between group of tasks. Please contact the {{groupName}}'s admin", {itemName, groupName})
            return false
        }
        if(!allowDragWhenSort()) {
            managerTableKeepGlobalData.showSnackbar("To rearrange items manually, please disable prior sorting")
            return false
        }
        if(!allowDragWhenFilters()) {
            managerTableKeepGlobalData.showSnackbar("To rearrange items manually, please clear the filters")
            return false
        }

        const moveInClosedLane = isDragInClosedLane(context)

        if(moveInClosedLane) {
            onMoveInClosedLaneManual(context)
            return false
        }

        const typeEndDrag = getCaseForDragEnd(context)

        if(typeEndDrag === 'itemEnd') {
            return resolveItemDragForEnd(context)
        }
        if(typeEndDrag === 'laneEnd') {
            return resolveLaneDragForEnd(context)
        }


        const type = getCase(context.startRecord)
        if(!!denyDropType(type)) return false

        switch (type) {
            case 'lane': {
                return resolveLaneDrag(context)
            }
            case 'item': {
                return resolveItemDrag(context)
            }
            default:
                return false
        }
    }, [])

    const gridRowDrop = useCallback(({context}) => {
        if(!context.valid) return false
        const typeEndDrag = getCaseForDragEnd(context)

        if(typeEndDrag === 'laneEnd') {
            const info = getDataForMoveSubLaneLastPos(context)
            if(!info) return false
            moveLaneView(info)
            return true
        }

        if(typeEndDrag === 'itemEnd') {
            const info = getDataForMoveSubLaneItemLastPos(context)
            if(!info) return false
            moveSubLaneItem(info)
            return true
        }

        const type = getCase(context.startRecord)
        if(!!denyDropType(type)) return false

        switch (type) {
            case 'lane': {
                const info = getDataForMoveSubLane(context)
                if(!info) return false
                moveLaneView(info)
                return true
            }
            case 'item': {
                const info = getDataForMoveSubLaneItem(context)
                if(!info) return false
                moveSubLaneItem(info)
                return true
            }
            default:
                return false
        }

    }, [])

    const rowReorderFeature = useMemo(() => ({
        disabled: false,
        hoverExpandTimeout: 1000000,
        listeners: {
            gridRowBeforeDragStart,
            gridRowDrag,
            gridRowDrop,
            gridRowBeforeDropFinalize,
        },
    }), [])

    return [rowReorderFeature, updateMove]
}